import { FC, memo, useEffect, useMemo, useState } from 'react';
import { ButtonStar, ButtonStarChangeType } from '../ButtonStar/ButtonStar';

interface StarRatingProps {
  value: number;
  disabled?: boolean;
  className?: string;
  onChange: (value: number) => void;
}

export const StarRating: FC<StarRatingProps> = memo(
  ({ value, disabled, className = '', onChange }) => {
    const [rating, setRating] = useState<number>(value);

    const stars = useMemo(() => Array.from({ length: 5 }, (_, index) => index + 1), []);

    useEffect(() => {
      setRating(value);
    }, [value]);

    const handleChange = (newValue: number, type: ButtonStarChangeType) => {
      if (type === 'hover') {
        setRating(newValue);
        return;
      }

      if (type === 'leave') {
        setRating(value);
        return;
      }

      setRating(newValue);
      onChange(newValue);
    };

    return (
      <div className={`flex flex-1 items-start justify-end gap-1 ${className}`}>
        {stars.map((starValue) => (
          <ButtonStar
            key={starValue}
            value={starValue}
            isActive={starValue <= rating}
            disabled={disabled}
            onChange={handleChange}
          />
        ))}
      </div>
    );
  }
);
